import {getPricingOption} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {getSummaryTicketPrice} from '../../../../selectors/placed-order'
import {OrderedTicket} from '../../../../types'
import {SummaryRow} from '../summary-row'
import {TicketProps} from './interfaces'
import {classes} from './ticket.st.css'

const getTicketName = (ticket: OrderedTicket) =>
  ticket.pricingOptionId ? `${ticket.name} (${getPricingOption(ticket, ticket.pricingOptionId).name})` : ticket.name

export const Ticket = ({ticket}: TicketProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const {labeledPrice, total} = getSummaryTicketPrice(ticket, t, getFormattedMoney)

  const getTicketAriaLabel = () => {
    const name = `${t('ticketsThankYou.ticketName')}: ${ticket.name}`
    const qty = t('mobile.thanks.quantity', {quantity: ticket.orderedCount})
    return `${name}, ${labeledPrice}, ${qty}`
  }

  return (
    <div data-hook={DH.TICKET} className={classes.container} aria-label={getTicketAriaLabel()}>
      <SummaryRow label={getTicketName(ticket)} value={total} />
      <Text className={classes.quantity} data-hook={DH.TICKET_QUANTITY}>
        {t('mobile.thanks.quantity', {quantity: ticket.orderedCount})}
      </Text>
    </div>
  )
}
